<template>
  <vs-popup class="currency-adjust-activity-log-pop-up"
            id="popup"
            :title="`${code} - FOREX RATE LOGS`"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <div slot="no-body" class="mt-4" v-can="'view-product-stock-adjust-log'">
        <vs-table
          id="sundry-item-list-table"
          :max-items="(meta.per_page) ? meta.per_page : 10"
          :data="logs"
          sort
          :sst="true"
          stripe class="table-dark-inverted table-auto vs-con-loading__container">

          <template slot="thead">
            <vs-th width="20%">DATE/TIME</vs-th>
            <vs-th width="20%" >USER</vs-th>
            <vs-th width="20%" >CHANGE TYPE</vs-th>
            <vs-th width="20%" >PREVIOUS FX VALUE</vs-th>
            <vs-th width="20%" >UPDATED FX VALUE</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


              <vs-td :data="data[indextr].created_at">
                {{ __dateTimeFormatter(data[indextr].created_at)}}
              </vs-td>

              <vs-td :data="data[indextr].causer_name">
                {{ data[indextr].causer_name}}
              </vs-td>

              <vs-td :data="data[indextr].description">
                <vs-chip transparent :color="data[indextr].description === 'updated' ? 'warning' : 'primary'">
                  {{ data[indextr].description}}
                </vs-chip>
              </vs-td>


              <vs-td class="font-semibold" :data="data[indextr].properties.old.fx_value">
                {{ data[indextr].properties.old.fx_value}}
              </vs-td>

              <vs-td class="font-semibold" :data="data[indextr].properties.attributes.fx_value">
                {{ data[indextr].properties.attributes.fx_value}}
              </vs-td>

            </vs-tr>
          </template>


        </vs-table>

        <vs-pagination
          v-on:changeMaxItems="changePage"
          :size-array="meta.total ? meta.total : 20"
          :max-items="perPage"
          description-body="Rows per page"
          description-connector="of"
          description-title="Records"
          description
          :description-items="descriptionItems"
          :total="(meta.last_page)? meta.last_page : 0"
          v-model="page"  class="p-5">
        </vs-pagination>


      </div>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const ActivityRepository = RepositoryFactory.get('activity')
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {defaultPagination, perPageList} from "@/constants/config";

  function initialState() {
    return {
      open: false,
      id: '',
      code: '',
      logs: [],
      filters: {},
      page : 1,
      total: 0,
      meta : {},
      sort : '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
    }
  }

export default {
  name: 'CurrencyAdjustLogPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id, code) {
      try {
        await Object.assign(this.$data, initialState())
        this.id = id
        this.code = code
        this.open = true;
      } catch (error) {
      }
    },
    async fetchCurrencyAdjustLog() {
      await this.$vs.loading({
        container: '#sundry-item-list-table',
        scale: 0.45
      })
      try {
        const {data} = await ActivityRepository.getCurrencyAdjustLog(this.id, this.page, this.perPage)
        this.logs =  data.data
        this.meta = data
      } catch (e) {
        this.showWarningMessage('Something went wrong. Please try again!')
      }
      this.$vs.loading.close('#sundry-item-list-table > .con-vs-loading')
    },
    filterQueryUpdate (){
      if (this.id) {
        this.fetchCurrencyAdjustLog()
      }
    },

    handleChangePage(page) {
      this.page=page;
      this.fetchCurrencyAdjustLog()
    },
    handleSort(key, active) {
      if(key){
        active = (active==='desc')? "-":'';
        this.sort=active+key;
        this.fetchCurrencyAdjustLog()
      }

    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
  },
  async mounted () {
  },
  mixins : [Filter, SuccessMessage, ErrorMessages],
  watch : {
    page(){
      this.fetchCurrencyAdjustLog()
    },
    perPage() {
      this.fetchCurrencyAdjustLog()
    }
  }
}
</script>

<style scoped>
  .currency-adjust-activity-log-pop-up >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 50% !important;
  }

</style>
